import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { IconWrapper, ItemIcon } from './styled';

const Wrapper = styled.li`
  height: 40px;
`;

const ItemLink = styled(NavLink)`
  align-items: center;
  color: var(--heading-primary);
  display: flex;
  font-size: var(--regular);
  font-weight: var(--normal);
  height: 100%;
  padding-left: 36px;
  text-decoration: none;

  &.active,
  &:hover,
  &:focus {
    background-color: var(--nav-item-hover);

    ${ItemIcon} {
      color: var(--primary);
    }
  }

  &.active {
    font-weight: var(--bold);
  }
`;

const NavItem = ({ exact, icon, label, to }) => (
  <Wrapper>
    <ItemLink exact={exact} to={to}>
      <IconWrapper>
        <ItemIcon icon={icon} />
      </IconWrapper>
      {label}
    </ItemLink>
  </Wrapper>
);

NavItem.propTypes = {
  exact: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default NavItem;
